import React from 'react';
import {styled} from '@mui/material';
import {Modal, Body, Button, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

interface RemoveConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isRemoving: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  confirmingLabel?: string;
}

const StyledModalContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  textAlign: 'center',
});

const StyledButtonRow = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
  marginTop: '8px',
});

function RemoveConfirmationModal({
  open,
  onClose,
  onConfirm,
  isRemoving,
  title,
  message,
  confirmLabel,
  confirmingLabel,
}: RemoveConfirmationModalProps) {
  const displayTitle = title ?? translate('Remove Creator');
  const displayMessage =
    message ??
    translate('Are you sure you want to remove this creator from CRM?');
  const displayConfirm = confirmLabel ?? translate('Remove');
  const displayConfirming = confirmingLabel ?? translate('Removing...');

  return (
    <Modal
      open={open}
      handleClose={isRemoving ? undefined : onClose}
      size="small"
    >
      <StyledModalContent>
        <Headline size="md">{displayTitle}</Headline>
        <Body size="md">{displayMessage}</Body>
        <StyledButtonRow>
          <Button
            mode="tinted"
            appearance="neutral"
            size="medium"
            onClick={onClose}
            disabled={isRemoving}
          >
            {translate('Cancel')}
          </Button>
          <Button
            mode="filled"
            appearance="neutral"
            size="medium"
            onClick={onConfirm}
            disabled={isRemoving}
          >
            {isRemoving ? displayConfirming : displayConfirm}
          </Button>
        </StyledButtonRow>
      </StyledModalContent>
    </Modal>
  );
}

export default RemoveConfirmationModal;
